import MicroServicesPage from '../aws/MicroServicesPage';

export default function FqdnManagementPage() {
  return MicroServicesPage('aws-customer-portal-fqdn-management');
}
